var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" - "+_vm._s(_vm.$t("compensation.additional2", { amount: _vm.amount, expenseType: _vm.expenseType, }))+" "),(_vm.customerData.length > 1)?_c('span',[_vm._v(_vm._s(_vm.$t("compensation.additional3")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }